export const testAttrName = 'data-test';
export const testAttr = (testId) => {
    if (!testId)
        return;
    return { [testAttrName]: testId };
};
export const testSelector = (testId) => `[${testAttrName}="${testId}"]`;
//# sourceMappingURL=instrumentation.js.map